import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React from 'react';
import {
  Dimensions,
  FlatList,
  Image,
  ImageStyle,
  Platform,
  RefreshControl,
  Text,
  TouchableOpacity,
} from 'react-native';
import {isBase64Image} from '../../../common/utils/functions';
import {getColNumbers} from '../../../common/utils/rendering';
import config from '../../../data/config';
import {StackParams} from '../../../data/types/navigation';
import {globalStyle} from '../../styles/globalStyle';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'Glossaire'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ProduitItem(props: any) {
  const {navigate} = useNavigation<NavigationProps>();

  const {
    data,
    isCatalogue,
    titleParent,
    refreshing,
    refreshList,
    idContrat,
    isDetailContrat,
    typeContrat,
    agenceAro,
  } = props;

  const montant =
    props.data &&
    props.data.items &&
    props.data.items[0] &&
    props.data.items[0].montant;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMove = ({item}: {item: any}) => {
    if (item.destinationPage === 'SouscriptionAssuranceScolaireForm') {
      navigate('SouscriptionAssuranceScolaireForm', {
        montant: montant,
        typeId: item.id,
      });
    } else if (item.destinationPage === 'SouscriptionAssuranceRetraiteForm') {
      navigate('SouscriptionAssuranceRetraiteForm', {
        premierVersement: montant,
      });
    } else {
      if (isDetailContrat) {
        if (item && item.isPdf) {
          item.action();
        } else {
          navigate(item.destinationPage, {
            agenceAro: agenceAro,
            idContrat: idContrat,
            typeContrat: typeContrat,
            typeId: item.id,
          });
        }
      } else {
        if (item && item.destinationPage) {
          navigate(item.destinationPage, {
            id: item.data || item.id,
            headerTitle: item.headerTitle,
            typeId: item.id,
          });
        } else {
          if (typeof item?.action === 'function') {
            item.action();
          } else {
            navigate('DemarcheCategorie', {
              data: item.id,
              isCatalogue: isCatalogue,
              libelle: item.libelle,
              titleParent:
                Platform.OS === 'web'
                  ? titleParent + ' > ' + item.libelle
                  : item.libelle,
            });
          }
        }
      }
    }
  };

  return (
    <FlatList
      data={data.items || []}
      style={
        Platform.OS === 'web'
          ? globalStyle.containerFluid
          : styles.containerFluid
      }
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={refreshList} />
      }
      contentContainerStyle={{paddingBottom: 20}}
      columnWrapperStyle={{flexWrap: 'wrap'}}
      keyExtractor={item => {
        return item.id;
      }}
      numColumns={getColNumbers(Dimensions.get('window'))}
      // key={}
      key={`produit_${getColNumbers(Dimensions.get('window'))}`}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      renderItem={({item}: {item: any}) => {
        const link = /^\d/.test(item.imageUrl)
          ? 'api/common/content/'
          : 'public/';

        return (
          <TouchableOpacity
            style={[
              Platform.OS === 'web'
                ? globalStyle.containerMenuItem
                : styles.containerMenuItem,
            ]}
            key={item.title}
            onPress={() => {
              handleMove({item});
            }}>
            <Image
              style={
                (Platform.OS === 'web'
                  ? globalStyle.MenuItemLogo
                  : styles.MenuItemLogo) as ImageStyle
              }
              source={
                typeof item.imageUrl === 'string' &&
                !isBase64Image(item.imageUrl)
                  ? {uri: `${config.baseURL}${link}${item.imageUrl}`}
                  : item.imageUrl
              }
            />
            <Text
              style={
                Platform.OS === 'web'
                  ? globalStyle.MenuItemFont
                  : styles.MenuItemFont
              }>
              {item.libelle}
            </Text>
          </TouchableOpacity>
        );
      }}
    />
  );
}
